export interface CertificateStatusInfo {
  label: string;
  variant: 'destructive' | 'warning' | 'default' | 'secondary';
  color: string;
  bgColor: string;
  textColor: string;
}

type Translate = (key: string, defaultValue: string) => string;

export function getCertificateStatus(
  daysUntilDue: number | null,
  t?: Translate,
): CertificateStatusInfo {
  const tr: Translate = t || ((_k, d) => d);
  if (daysUntilDue === null) {
    return {
      label: tr('calibration.statusNoDueDate', 'No Due Date'),
      variant: 'secondary',
      color: 'text-muted-foreground',
      bgColor: 'bg-gray-100',
      textColor: 'text-gray-600',
    };
  }
  if (daysUntilDue < 0) {
    return {
      label: tr('calibration.statusOverdue', 'Overdue'),
      variant: 'destructive',
      color: 'text-destructive',
      bgColor: 'bg-red-50 border-red-200',
      textColor: 'text-red-600',
    };
  }
  if (daysUntilDue <= 30) {
    return {
      label: tr('calibration.statusDueSoon', 'Due Soon (30 days)'),
      variant: 'warning',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50 border-orange-200',
      textColor: 'text-orange-600',
    };
  }
  if (daysUntilDue <= 90) {
    return {
      label: tr('calibration.statusUpcoming', 'Upcoming (30-90 days)'),
      variant: 'default',
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-50 border-yellow-200',
      textColor: 'text-yellow-600',
    };
  }
  return {
    label: tr('calibration.statusOk', 'OK'),
    variant: 'secondary',
    color: 'text-green-600',
    bgColor: 'bg-green-50 border-green-200',
    textColor: 'text-green-600',
  };
}

export function formatCertificateDate(dateStr: string | null): string {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString();
}
